export const METADATA = {
    title: "You've Been Idle",
    message:
        "Your session is about to time out due to inactivity! Please click to continue session.",
};
